import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useStateValue } from "../../stateprovider";
import '../../css/CssDoctorRegistration.css';
import check from '../../assets/ckeck.png'
import crumb from '../../assets/crumbs1.png';
import favDocLogo from '../../assets/favdoctor logo 1.png';
import backGround from '../../assets/login-bg.png';
import m_background from '../../assets/mbil-service.png';
import Logo from '../../components/logo/Logo'
import '../land/land.css';
import LoginHeader from '../../components/Header/LoginHeader'


function UserRegistration() {
    const navigate = useNavigate();
    const [{ user }, dispatch] = useStateValue();
    const [surname, setSurname] = useState("");
    const [firstName, setFirstName] = useState("")
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch({
            type: "CREATE_USER",
            user: { surname: surname, firstName: firstName, email: email, address: address, phone: phone }
        });
        navigate('/User_SignUp_Step2');
    }
    let date = new Date();
    let year = date.getFullYear();


    return (
        <div className="DocRegMain" >

            <div className="DocRegMain__BackgroundImage">
                <img src={backGround} alt="BackgroundImage" />
                <img src={m_background} alt="BackgroundImage"/>

            </div>
            {/*<div className="DocRegMain__Header">
              
                <article className='favdoc__land-nav' style={{ zIndex: 20 }}>
                    <Logo />
                    <div className='favdoc__land-nav_login'>
                        <Link to="/">
                            Back
                        </Link>
                    </div>
                </article>
    </div>*/}
            <LoginHeader />
            <div className="UserRegMain__SignUpSection">
                <div className="UserRegMain__SignUpForm">
                    <form onSubmit={handleSubmit}>
                        <img src={crumb} alt="Crumbs" style={{ marginBottom: 25 + 'px' }} />
                        {/*<p style={{
                            margin: 0, fontStyle: "normal", color: "#0F0F0F",
                            letterSpacing: 0.01 + 'rem'
                        }}> Hello! I'm <span style={{ color: "#01B6E2", paddingLeft: 5 + 'px' }}>FavDoctor,
                    </span></p>
                    <p style={{ margin: 0, fontStyle: "normal", color: "#0F0F0F" }}>I want to get to know you</p>*/}
                        <div className={((firstName.length >= 3) && (surname.length >=3)) ? "complete active UserRegMain__FormName" : "active UserRegMain__FormName"}>
                            <div className="input-check">
                                <input type="text" placeholder="Surname" value={surname}
                                    onChange={(e) => setSurname(e.target.value)}
                                    name="Surname" required />
                                <input type="text" placeholder="First Name" value={firstName} onChange={(e) => {
                                    setFirstName(e.target.value);
                                }} name="FirstName" required />
                                    <img src={check} alt="" className={((firstName.length >= 3) && (surname.length >=3)) ? "display" : "check"}  style={{width: "fit-content"}}/>
                                          </div>             </div>
                        <div className={(email) ? "complete active input-check" : "disabled input-check"}>

                            <input type="email" placeholder="Email" disabled={(firstName.length < 3)} value={email}
                                onChange={(e) => setEmail(e.target.value)}  name="Email" required />
                                <img src={check} alt="" className={(email.length > 3) ? "display" : "check"} style={{width: "fit-content"}}/>
                        </div>
                        <div className="UserRegMain__SignUpContact">
                            <div className={(phone.length === 11) ? "complete active  phone input-check" : "phone input-check disabled"} style={{ margin: 0 }}>

                                <input type="number" placeholder="Mobile Number" disabled={!email} value={phone} onChange={(e) => setPhone(e.target.value)} minLength="11" maxLength="11"  name="phone" required />
                                    <img src={check} alt="" className={(phone.length === 11) ? "display" : "check"} style={{width: "fit-content"}}/>
                            </div>
                            <div className={address ? "complete active input-check address" : "address input-check disabled"} style={{ margin: 0 }}>

                                <input type="text" placeholder="Address" disabled={phone.length !== 11} value={address} onChange={(e) => setAddress(e.target.value)} name="address" required />
                                    <img src={check} alt="" className={(address.length > 5) ? "display" : "check"} style={{width: "fit-content"}}/>
                            </div>
                        </div>

                        <button className={!address ? "disabled_button" : "button disabled_button"} disabled={!address}>Continue</button>

                    </form>
                    <p style={{
                        marginBottom: 0, color: "#0F0F0F",
                        fontWeight: 300, fontStyle: 'italic'
                    }}>Already have an account?<Link to="/login">
                            <span style={{ color: "#01B6E2", fontStyle: "normal", cursor: "pointer", textDecoration: "none", paddingLeft: 5 + 'px' }}>
                                <b>Login</b></span></Link> </p>

                </div>
            </div>

            <div className="DocRegMain__Footer">
                <div className="DocRegMain__Brand">
                    <p>&copy; {year} FavDoctor</p>
                </div>
            </div>

        </div>
    )
}

export default UserRegistration;